import { render } from "./Phone.vue?vue&type=template&id=d4ae7126&ts=true"
import script from "./Phone.vue?vue&type=script&lang=ts"
export * from "./Phone.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__